import { TagHandling } from "services";

export const generateExcerpt = (
  content: string,
  tags: string[] = []
): string => {
  const maxWords = 100;
  const tagHandler = new TagHandling();

  if (!content) return "";

  const cleanContent = content
    .replace(/<h[1-6].*?>.*?<\/h[1-6]>/g, "")
    .replace(/<ul>.*?<\/ul>/g, "")
    .replace(/[^.!?]+:[^.!?]*(\s|$)/g, "")
    .replace(/<[^>]+>/g, "")
    .replace(/\.(?=[A-Z])/g, ". ")
    .replace(/\s+/g, " ")
    .trim();

  const sentences = cleanContent
    .split(/(?<=[.!?])\s+/)
    .filter((sentence) => sentence.length > 0);

  const scoredSentences = sentences
    .map((sentence, index) => ({
      text: sentence,
      score: calculateScore(sentence, tags, index, tagHandler),
    }))
    .filter(({ score }) => score > 0);

  let excerpt = "";
  let wordCount = 0;

  scoredSentences
    .sort((a, b) => b.score - a.score)
    .some(({ text }) => {
      const words = text.split(/\s+/);
      if (wordCount + words.length > maxWords) return true;
      excerpt += (excerpt ? " " : "") + text;
      wordCount += words.length;
      return false;
    });

  return excerpt;
};

const calculateScore = (
  sentence: string,
  tags: string[],
  index: number,
  tagHandler: TagHandling
): number => {
  if (!sentence || typeof sentence !== "string" || !sentence.trim()) {
    return 0;
  }

  let score = 0;
  const lowerSentence = sentence.toLowerCase();

  const matchedTags = tags
    .filter((tag): tag is string => typeof tag === "string" && !!tag)
    .filter((tag) => lowerSentence.includes(tag.toLowerCase()));

  if (matchedTags.length > 0) {
    matchedTags.forEach((tag) => {
      score += tagHandler.getTagWeight(tag);
    });
  }

  const positionScore = Math.max(0, 4 - index * 2);
  score += positionScore;

  const wordCount = sentence.split(/\s+/).length;
  if (wordCount >= 10 && wordCount <= 30) score += 1;

  if (/\d+/.test(sentence)) score += 1;

  return score;
};
